

import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnDestroy } from '@angular/core';
// import { NzNotificationService, NzMessageService, UploadFile, UploadXHRArgs } from 'ng-zorro-antd';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { concatMap, startWith, take, filter } from 'rxjs/operators'
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  RequirementDO,
  /* Document Manager */
  AppConfig,
  EntityDocumentDO,
  IntimationService,
  AppMetadataHandler,
  ClaimRegistrationService,
  UserInfoService,
} from 'app';

import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin, Observable, Observer } from 'rxjs';
import { environment } from 'environments/environment';
import * as moment from 'moment/moment';
import { IntBulkProcLogDO } from 'app/BaseFramework/shared/models/IntBulkProcessLog.model';
import { IntimationStagingDocumentDO } from 'app/BaseFramework/shared/models/IntimationStagingDocument.model';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';



@Component({
  selector: 'app-process-bulk-upload',
  templateUrl: './process-bulk-upload.component.html',
  styleUrls: ['./process-bulk-upload.component.scss']
})
export class ProcessBulkUploadComponent implements OnInit {

  constructor(
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private commonUtility: CommonUtilty,
    private notification: NzNotificationService,
    private intimationService: IntimationService,
    /* Document Manager */
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private msg: NzMessageService,
    private appConfig: AppConfig,
    public appMetadataHandler: AppMetadataHandler,
    private activatedRoute: ActivatedRoute,
    private userInfoService: UserInfoService,
    private claimRegistrationService: ClaimRegistrationService
  ) { }

  stateToProgressMapper = {};
  configData: any = this.appMetadataHandler.configDataJSON;
  ngOnInit() {
    this.stateToProgressMapper = this.configData.stateToProgressMapper
    this.initializeProcessBulkTransaction();
    this.userRoleDO = this.userInfoService.getUserRoleDO();
    this.filteredClaimStageLookup = this.claimStages
  }

  ngOnDestroy(){
    this.transactionGuid = null;
  }

  dataSet = [{}, {}];
  sortDataSet =[];

  handleFileUpload(data) {
    console.log(data);
  }



  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    'source': environment.applicationSource,
    'hash': '7h1nk[)j',
  });


  _transactionInProgress = false;
  BulkIntimationReqResp = {};
  stagingProcDO = new IntBulkProcLogDO();
  stagingDocument = new IntimationStagingDocumentDO();
  userRoleDO: string = null;

  fileListTemp: NzUploadFile[] = [];
  uploading: boolean = false;
  fileUploadEndpoint: string;
  nextClaimStage
  filteredClaimStageLookup = []
  mapperTransactionState = "bulkApproval";
  _inboxType = null;
  claimStages = [
    {
        "lookupKey": "APPROVE",
        "lookupValue": "Approve",
        "sortOrder": 1,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    },
    {
        "lookupKey": "REJECT",
        "lookupValue": "Reject",
        "sortOrder": 3,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    },
    {
        "lookupKey": "SUBMIT",
        "lookupValue": "Submit",
        "sortOrder": 3,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    }
]

// sortConfig = {
//   title: 'Pending Requirement',
//   compare: (a: DataItem, b: DataItem) => a['pendingAllReqFl'] - b['pendingAllReqFl'],
//   priority: 1
// }

private _payloadInEdit = null
  set payloadInEdit(value: any) {
    if (this._payloadInEdit == null) {
      this._payloadInEdit = this.commonUtilty.deepCopy(value)
    }
    else {
      throw "You cannot set payloadInEdit, since it's a constant and can be initialized only once"
    }
  }

  get payloadInEdit() {
    return this._payloadInEdit
  }
  lookupsToBind = ['claimStageCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  fileUploadBefore = (file: NzUploadFile, fileList): boolean => {
    const isFileTypeSupported = file.type.includes('application/vnd.ms-excel')// .xlxs to be removed(confirmed by Ganesh on 30092021)
    if(!isFileTypeSupported){
      this.msg.error(`Unsupported file type. Please select a excel file`);
      return false;
    } else {
      this.preUploadImgChecks(file).subscribe(
        n => {
          if (n) { //n = true => All passed
            this.fileListTemp = []; //reset
            this.fileListTemp.push(file); //push
            this.fileUpload(file);
            return true;
          }
        },
        e => { },
        () => { }
      );
      return true;
    }
  };
  fileRemove = (file: NzUploadFile): boolean => {
    //alert('Cannot remove uploaded file. Please upload new file to replace');
    //return false;
    return true;
  };

  preUploadImgChecks = (file: NzUploadFile) => {
    return new Observable((observer: Observer<boolean>) => {
      /* Bypass checks * /
      observer.next(true);
      observer.complete();
      return;
      /* */
      /* Max File Size */
      const maxFileSize = 4; /* in MB */

      /* Supported file types */

      //const isSupportedFileType = file.type.includes('application/vnd.ms');
      const isSupportedFileType = file.type.includes('application/vnd.ms-excel');
      // || file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') // .xlxs to be removed(confirmed by Ganesh on 30092021)

      if (!isSupportedFileType) {
        this.msg.error(`Unsupported file type. Please select a excel file`);
        // observer.complete();
        // this.initDocumentData(this.documents, this.requirements); //reset
        return;
      }
      const fileSizeOK = file.size / 1024 / 1024 < maxFileSize;
      if (!fileSizeOK) {
        this.msg.error(`Image must smaller than ${maxFileSize} MB`);
        observer.complete();
        //this.initDocumentData(this.documents, this.requirements); //reset
        return;
      }
      observer.next(isSupportedFileType && fileSizeOK);
      observer.complete();
      return;
    });
  };

  showUpload = true;

  fileUpload(file): void {
    let url = this.fileUploadEndpoint;
    const formData = new FormData();
    this.uploading = true;
    // Set Data

    this.stagingProcDO.batchStatusCd = "STARTED";
    let options = {
      reportProgress: true,
      headers: this.headers,
    };
    this.BulkIntimationReqResp['stagingProcDO'] = this.stagingProcDO;
    formData.append('json', JSON.stringify(this.BulkIntimationReqResp));
    // Attach File(s) [1 in this case]
    //this.fileListTemp.forEach((file: any) => { formData.append('file', file) });
    formData.append('file', file)
    const req = new HttpRequest('POST', url, formData, options);
    this.http
      .request(req)
      .pipe(filter(e => e instanceof HttpResponse))
      .subscribe(
        (e: {}) => {
          let response: any = e;
          if (response.body['exceptionDOList'] && response.body['exceptionDOList'].length > 0) {
            response.body.exceptionDOList.forEach(element => {
              element.exceptionMaster.exceptionMsgDO.forEach(innerElement => {
                this.msg.error(innerElement.message);
              });
            });
            this.uploading = false;
            this.fileListTemp = [];
            this.showUpload = false;
            setTimeout(() => { this.showUpload = true; }, 200);
          }
          else {
            this.uploading = false;
            this.msg.success(`File uploaded successfully batch id is ${response.body.stagingProcDO['batchId']}`, { nzDuration: 4000 });
            this.fileListTemp = [];
            this.showUpload = false;
            setTimeout(() => { this.showUpload = true; }, 200);

          }

          // this.initDocumentData(this.documents, this.requirements);
        }, e => {
          this.uploading = false;
          this.msg.error('Upload failed');

        }
      );
  }


  bulkMetaDataList = [];
  bulkStatusData = [];
  bulkStatusDataFiltered : DataItem[];
  metaDataEntityGuid = null;
  allChecked: boolean = false
  initializeProcessBulkTransaction() {
    this.activatedRoute.data.subscribe(data => {
      this._inboxType = data['inboxType']

    });
    this.interactService.processBulkIntimationTransactionSubject$.pipe(take(1)).subscribe(res => {
      console.log("check bulk list received: ", res)
      this.bulkStatusData = res['bulkList'];
      this.bulkStatusDataFiltered = res['bulkList'];
      this.sortDataSet = res['bulkList']; // used for sorting table data.
      this.payloadInEdit = res['bulkData']
      this.getClaimStatusUIFilter(this.bulkStatusDataFiltered)
      console.log("received bulk List : ", res['bulkList'])
      console.log("received bulk Data : ", res['bulkData'])
    });
  }

  listOfCategories = [];
  getClaimStatusUIFilter(bulkData) {
    if (this.commonUtilty.isArrayIterable(bulkData)) {
      for (let i = 0; i < bulkData.length; i++) {
        if(bulkData[i]['claimStatus']){
          let text = bulkData[i]['claimStatus'].toLowerCase();
        let formattedText = text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
        let category = { text: formattedText, value: bulkData[i]['claimStatus'] };
        // this.listOfCategories.push(category);
        this.listOfCategories = this.commonUtility.uniquePushInArray(this.listOfCategories,category,'value')
        }
        
      }
    }
  }

  openBulkUploadModal = false
  batchId = null;
  bulkDocumentUploadHandler(data) {
    this.openBulkUploadModal = true;
    console.log("batch details check: ", this.payloadInEdit)
    if(this.payloadInEdit && this.payloadInEdit.batchId)
      this.batchId = this.payloadInEdit.batchId
  }

  selectedFilter = null;
  filterCasesOnCategory(filterArray) {
    if (filterArray) {
      this.bulkStatusDataFiltered = this.bulkStatusData.filter(item => item.claimStage === filterArray);
      this.filterStageList()
    } else {
      this.bulkStatusDataFiltered = this.bulkStatusData
      this.filteredClaimStageLookup = this.claimStages
    }

    if (this.userRoleDO && this.userRoleDO['roleId'] == 'PARTNER'){
      let filterPartnerSpecificOption = this.filteredClaimStageLookup.filter(e => e.lookupKey != "APPROVE")
      this.filteredClaimStageLookup = this.commonUtility.deepCopy(filterPartnerSpecificOption)
    }
  }

  updateAllChecked() {
    if (Array.isArray(this.bulkStatusDataFiltered)) {
      if (this.allChecked)
        this.bulkStatusDataFiltered.forEach(item => { item["isSelectedCase"] = true; })
      else this.bulkStatusDataFiltered.forEach(item => { item["isSelectedCase"] = false; })
    }
  }

  getLocalDateString(rawDate) {
    let dateString
    let tempDate = this.commonUtilty.deepCopy(rawDate)
    tempDate = this.commonUtilty.serverDOtoUIDODate(tempDate);
    if (tempDate != null) {
      dateString = moment(tempDate).format('DD MMM YYYY');
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  submitTransaction() {
    console.log("check selected flag is true: ", this.bulkStatusDataFiltered)
    console.log("selected stages on: ", this.nextClaimStage)
    let isSelected = this.bulkStatusDataFiltered.filter(e=>e.isSelectedCase)
    let URL = 'bulk/intimation/proceedAction'
    let body = {
      "BulkProcessDataDTO": isSelected,
      "processCd": this.nextClaimStage
    }
    console.log("request body to process: ", body)
    if(isSelected && this.commonUtility.isArrayIterable(isSelected)){
    // this.intimationService.bulkProcess(URL,body).subscribe(resp => {
    //   console.log("resp of bulk process: ", resp)
    //   this.msg.success(`Request Submitted Successfully.`, { nzDuration: 4000 });
    //   this.router.navigate(['/app/claims/intimation/bulkUpload'])
    // })
    } else this.msg.error("Please select minimum 1 case.", { nzDuration: 3000 })
  }

  filterStageList(){
    if (this.selectedFilter && this.selectedFilter == "PENDING_DE") {
      this.filteredClaimStageLookup = this.claimStages.filter(e => e.lookupKey == "SUBMIT")
    }
    if (this.selectedFilter && this.selectedFilter != "PENDING_DE") {
      this.filteredClaimStageLookup = this.claimStages.filter(e => e.lookupKey != "SUBMIT")
    }
  }

  covertDateIntoUIFormat(bulkIO) {
    bulkIO.forEach(element => {
      element.eventDt = this.commonUtilty.serverDOtoUIDODate(element.eventDt)
      element.eventTm = this.commonUtilty.serverDOtoUIDOsetTime(element.eventTm)
    });
    return bulkIO;
  }

  HasError = false;
  checkAllErrors() {
    this.bulkMetaDataList.forEach(element => {

      // if(element.eventDt != element.eventDt)
      // {
      //   this.HasError=true;
      //   return;
      // }

      if (element.eventTm != element.eventTm1) {
        this.HasError = true;
        return;
      }

      if (element.eventTypeCd != element.eventTypeCd1) {
        this.HasError = true;
        return;
      } else if (element.proposalNum != element.proposalNum1) {
        this.HasError = true;
        return;
      }
      else if (element.insFirstName != element.insFirstName1) {
        this.HasError = true;
        return;
      } else {
        this.HasError = false;
      }

    });
  }

  visibleProcessButton = false;
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  datesAreEqual = false;
  onChange(event, type, eventDt) {

    var retypeEventDate = moment(event, "DD-MM-YYYY");
    var eventDate = moment(event, "DD-MM-YYYY");
    if (eventDate.format('DD-MM-YYYY') == retypeEventDate.format('DD-MM-YYYY'))
      this.datesAreEqual = true;

  }

  getTimeString(rawTime) {
    let timeString
    timeString = this.commonUtility.serverDOtoUIDOsetTime(rawTime);
    return new Date(timeString)
  }

  metadataArray = [];
  processRecord() {

    if (this.metadataArray.length == 0)
      this.notification.error('No records selected', 'Please select at least one record');
    else {
      this._transactionInProgress = true;
      this.intimationService.processBulkIntimation(this.metadataArray).
        subscribe(resp => {
          console.log("working............");
          this._transactionInProgress = false;
          this.msg.success(`Started Processing`, { nzDuration: 4000 })
          //this.router.navigate(['/app/claims/intimation/newBulk'])
          this.router.navigate(['/app/claims/inbox/workbench'])

        });
    }


  }

  openTransactionDetails(serviceTask: any, entityGuid: any, inboxType?) {
    let transactionDataIO: any = [];
    this.intimationService.getIntimationByGuid(entityGuid).
      subscribe(resp => {
        if (resp && Object.keys(resp).length) {
          transactionDataIO = resp;
          this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, null, null, inboxType)
          this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
        }
      });
  }
  openRegistrationTransactionDetails(stage: any, entityGuid: any, inboxType: any, migratedFl: any) {
    // let transactionDataIO: any = [];
    // let serviceTask = this.getTransactionState(stage)
    // this.claimRegistrationService.getHealthClaimDataByGuid(entityGuid).
    //   subscribe(resp => {
    //     if (resp && Object.keys(resp).length) {
    //       transactionDataIO = resp;
    //       this.interactService.sendIOToTransaction(serviceTask, 'CASHLESS', transactionDataIO, null, null, inboxType)
    //         this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
    //     }
    //   });
    
  }
  
  getTransactionState(stage){
    if (stage == 'PENDINGAUTOADJ' || stage == 'PENDINGMADJ')
      return 'healthClaimAdjudication'
    else if (stage == 'PENDINGPAYOUT')
      return 'healthClaimPayout'
    else if (stage == 'PENDING_DE')
      return 'healthClaimRegistration'
  }

  emitSelectedIntimation(event, data) {
    if (event) {
      let indexFound = this.metadataArray.findIndex(item => {
        if (item)
          return item === data;
      })
      if (indexFound === -1) {
        this.metadataArray.push(data)
      }
    }
    else {

      let output = this.metadataArray.filter(item => {
        if (item)
          return item !== data;
      }) || []
      this.metadataArray = output;
    }
  }

  serverDOtoUIDOsetTime(time) {
    let output = null
    if (time && Array.isArray(time)) {
      if (time.length > 4 || time.length === 4)
        output = time[0] + ":" + time[1] + ":" + time[2] + ":" + time[3];
      else if (time.length === 3)
        output = time[0] + ":" + time[1] + ":" + time[2] + ":" + 0;
      else if (time.length === 2)
        output = time[0] + ":" + time[1]
      else if (time.length === 1)
        output = time[0] + ":" + 0
      else
        output = null
    }
    else if (time) {
      output = new Date(time)
    }
    return output
  }

  //  Document manager related code

  documentFooter = true;
  documentModel = false;
  _saveStagingDoc = false
  stagingGuid = null;
  openDocumentModel(guid) {
    this.documentModel = true;
    this.stagingGuid = guid;
  }
  cancelDocument() {
    this.documentModel = false;
    this.stagingGuid= null;
    this.listOfStagingDocument = [];
    this.listOfFiles = [];
    this.listOfFileStagingDataMap = [];
    this.stagingDocument = new IntimationStagingDocumentDO();
  }

  // Pre upload file
  fileList = [];
  beforeUpload = (file): boolean => {
    this.fileList = this.fileList.concat(file);
    return false;
  };


  //FetchDocumentReq map requirenCd

  document;
  requirement

  listOfDocument = [];
  fetDocumetReqMapByRequirmentCode(requirementCd) {
    let pathVariables = [];
    pathVariables.push(requirementCd);
    let url = 'fetchDocumentReqMap';
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp => {
      console.log(JSON.stringify(resp))
      this.listOfDocument = resp;
    });
  }

  listOfStagingDocument = [];
  listOfFiles = [];
  listOfFileStagingDataMap = [];
  addStagingDocuments() {

    if (this.stagingDocument.requirement == null || this.stagingDocument.documentCd == null || this.stagingDocument.documentRecievedDt == null) {
      this.msg.error('Please select all mandatory fields');
      return;
    }
    if (this.fileList.length == 0) {
      this.msg.error('Please add at least one document');
      return;
    }

    let stagingDocumentCopy=this.commonUtilty.deepCopy(this.stagingDocument)
    this.listOfStagingDocument.push(stagingDocumentCopy);
    this.listOfFiles = this.fileList;
    let MapData = { stagingData: this.stagingDocument, stagingFileData: this.fileList }
    this.listOfFileStagingDataMap.push(MapData)
    this.fileList = [];
  }

  _saveDocInProgress=false;
  saveStagingDoc() {

    if (this.listOfStagingDocument.length == 0) {
      this.msg.error('Please first add requirement');
      return;
    }

    this._saveDocInProgress=true;
    let url = this.appConfig.baseApiPath + 'bulk/intMetadata/save/stagingDoc';
    //let url = "/bulk/intMetadata/save/stagingDoc/"
    const formData = new FormData();
    let options = {
      reportProgress: true,
      headers: this.headers,
    };

    /* Guid is intimationStagingDo's guid parent of stagingDocument*/
    formData.append('guid', this.stagingGuid);  
    var listSize = this.listOfFileStagingDataMap.length;
    var processCount = 0;

    /*listOfFileStagingDataMap is a combination of staging data  and file array */
    this.listOfFileStagingDataMap.forEach(element => {

      /* Staging data from map*/
      formData.append('json', JSON.stringify(element.stagingData));  

      /* Getting files*/
      element.stagingFileData.forEach(file => {
        formData.append('file', file)
      });

      const req = new HttpRequest('POST', url, formData, options);
      this.http.request(req).pipe(filter(e => e instanceof HttpResponse)).subscribe((e: {}) => {
        let response: any = e;
        processCount += 1;
        /*Resting all data when all got server response */
    if (listSize == processCount) {
        this.msg.success('Data saved successfully');
        this._saveDocInProgress=false;
      /*Resetting all list after successfull save */
        this.cancelDocument();
     }
      }, e => {
      this.uploading = false;
       processCount += 1
      this.msg.error('Upload failed');
      this._saveDocInProgress=false;
      }
      );

    });
    

    // /*Resting all data when all got server response */
    // if (listSize == processCount) {
    //   this.msg.success('Data saved successfully');
    //   this._saveDocInProgress=false;
    //   /*Resetting all list after successfull save */
    //   this.cancelDocument();
    // }else{
    //   this.msg.error('Upload failed');
    //   this._saveDocInProgress=false;
    // }

    // return 
    // formData.append('guid', this.stagingGuid);
    // formData.append('json', JSON.stringify(this.stagingDocument));
    // this.fileList.forEach(file => {   /* Adding multiple files with form data */
    //   formData.append('file',file)
    // });


    // const req = new HttpRequest('POST', url, formData, options);
    // this.http
    //   .request(req)
    //   .pipe(filter(e => e instanceof HttpResponse))
    //   .subscribe(
    //     (e: {}) => {
    //       let response: any = e;
    //       alert("Data uploaded successfully");  
    //     }, e => {
    //       this.uploading = false;
    //       this.msg.error('Upload failed');

    //     }
    //   );

  }

  docuPanelOpen = false;
  requiremets:any = [];
  documents:any = [];
  transactionGuid
  docuPanel(status) { this.docuPanelOpen = !!status }
  documentManagerHandler(guid) {
    if (guid) {
      this.transactionGuid = guid
      this.docuPanel(true)
       this.claimRegistrationService.getClaimDataByGuid(guid).
      subscribe(resp => {
       this.interactService.sendClaimIOForDocumentManager(this.commonUtilty.deepCopy(resp))
       this.requiremets = resp['requirementDOs'];
       this.documents = resp['entityDocumentDOs'];
      });
      
    }
    else {
      this.msg.error("Invalid Transaction")
    }
  }

  /* Date Fns */
  disabledDate = (current: Date): boolean => {
    let today = moment(new Date());
    let currentDate = moment(current);
    /* Future Date disable */
    let diff = today.diff(currentDate, 'days', true);
      return !(diff > 0);
    
    /* PS: Using (!)NOT because we want to disable dates that is NOT part of criteria */
  };

  sortName: any;
  sortValue:any;
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    this.search();
  }

  search(){
    if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.bulkStatusDataFiltered = this.commonUtilty.deepCopy(this.commonUtilty.sortObject(this.sortName, this.bulkStatusDataFiltered, orderBy))
    } else {
      this.bulkStatusDataFiltered = this.sortDataSet;
    }
    console.log("sorted searchResultsList", JSON.stringify(this.bulkStatusDataFiltered));
  }

  listOfColumn = [
    {
      title: 'Proposal Number',
      compare: (a: DataItem, b: DataItem) => a.proposalNum.localeCompare(b.proposalNum),
      priority: false
    },
    {
      title: 'Life Insured',
      compare: (a: DataItem, b: DataItem) => a.insuredFirstName.localeCompare(b.insuredFirstName),
      priority: false
    },
    {
      title: 'Claimant Name',
      compare: (a: DataItem, b: DataItem) => a.claimantFirstName.localeCompare(b.claimantFirstName),
      priority: false
    },
    {
      title: 'Event Type',
      compare: (a: DataItem, b: DataItem) => a.eventTypeCd.localeCompare(b.eventTypeCd),
      priority: false
    },
    {
      title: 'Event Date',
      compare: (a: DataItem, b: DataItem) => a.eventDt.localeCompare(b.eventDt),
      priority: false
    },
    {
      title: 'Intimation Date',
      compare: (a: DataItem, b: DataItem) => a.intimationDt.localeCompare(b.intimationDt),
      priority: false
    },
    {
      title: 'Intimation No',
      compare: (a: DataItem, b: DataItem) => a.clmIntimationNum.localeCompare(b.clmIntimationNum),
      priority: false
    },
    {
      title: 'Intimation Status',
      compare: (a: DataItem, b: DataItem) => a.intimationStatus.localeCompare(b.intimationStatus),
      priority: false
    },
    {
      title: 'Reg. Number',
      compare: (a: DataItem, b: DataItem) => a.claimNum.localeCompare(b.claimNum),
      priority: false
    },
    {
      title: 'Claim Status',
      compare: (a: DataItem, b: DataItem) => a.claimStatus.localeCompare(b.claimStatus),
      priority: false
    },
    {
      title: 'Pending Requirement',
      compare: (a: DataItem, b: DataItem) => a.pendingAllReqFl.localeCompare(b.pendingAllReqFl),
      priority: 1
    },
    {
      title: 'Requirement',
      compare: (a: DataItem, b: DataItem) => a.pendingAllReqFl.localeCompare(b.pendingAllReqFl),
      priority: false
    }
  ];
}
interface DataItem {
  proposalNum: string
  insuredFirstName: string
  claimantFirstName: string
  eventTypeCd: string
  eventDt: string
  intimationDt: string
  clmIntimationNum: string
  intimationStatus: string
  claimNum: string
  claimStatus: string
  pendingAllReqFl: string
  isSelectedCase: boolean
}









